import { Link } from "react-router-dom";
import contact from "../../assets/img/Untitled.png"
import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import SplitText from "gsap/SplitText"; // Make sure you have access to SplitText plugin
import HomepageFAQ from "../../AdminDashBoard/HomepageFAQ";

const Contact = ({ style_2 }) => {


  const handleFooterLink = (event) => {
    event.preventDefault(); // Prevent the link from immediately navigating
    window.scrollTo({ top: 0, behavior: 'smooth' });

    // Optionally, use a timeout to delay navigation
    setTimeout(() => {
      // Use the router's `history.push` to navigate
      window.location.href = '/contact_us'; // Or use your routing logic
    }, 500); // Delay for the scroll effect to complete
  };


  const containerRef = useRef();

  useEffect(() => {
    let ctx = gsap.context(() => {
      let splitTitleLines = gsap.utils.toArray(".anim_heading_title");

      splitTitleLines.forEach((splitTextLine) => {
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: splitTextLine,
            start: "top 90%",
            end: "bottom 60%",
            scrub: false,
            markers: false,
            toggleActions: "play none none none",
          },
        });

        const itemSplitted = new SplitText(splitTextLine, {
          type: "words, lines",
        });

        gsap.set(splitTextLine, { perspective: 400 });

        // optional: resplit if necessary
        itemSplitted.split({ type: "lines" });

        tl.from(itemSplitted.lines, {
          duration: 1,
          delay: 0.3,
          opacity: 0,
          rotationX: -80,
          force3D: true,
          transformOrigin: "top center -50",
          stagger: 0.1,
        });
      });
    }, containerRef);

    return () => ctx.revert();
  }, []);
  return (
    <>
      <div ref={containerRef}>
        {style_2 ? null : <div className="cs_height_150 cs_height_lg_60"></div>}

        <section>
          <div className="cs_bg cs_bg_img_about_titile" style={{ backgroundImage: `url(${contact})` }}>
            <div className="container">
              <div className="cs_learning_project">
                <div className="cs_section_heading cs_style_1">
                  <div className="cs_section_heading_text">
                    <h3 className="cs_section_title_3 cs_color_2 anim_heading_title font-inter">
                      {/* We'd be interested in learning more about your project. */}
                      Ready to Grow Your Business Online? Get a FREE Digital Marketing & IT Audit Today!
                    </h3>

                  </div>
                  <div className="cs_section_heading_right cs_btn_anim" style={{ display: 'flex', alignItems: 'center', gap: '14px', flexWrap: 'wrap' }}>
                    <Link
                      to="/contact_us"
                      onClick={handleFooterLink}
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '10px',
                        padding: '14px 28px',
                        borderRadius: '999px',
                        background: '#ff7e00',
                        color: '#ffffff',
                        fontWeight: 700,
                        fontSize: '16px',
                        textTransform: 'uppercase',
                        textDecoration: 'none',
                        boxShadow: '0 20px 36px rgba(255, 126, 0, 0.22)',
                        transition: 'transform 0.25s ease, box-shadow 0.25s ease',
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateY(-2px)';
                        e.currentTarget.style.boxShadow = '0 24px 48px rgba(255, 126, 0, 0.28)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = '0 20px 36px rgba(255, 126, 0, 0.22)';
                      }}
                    >
                      <span>Get Free Consultation</span>
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 19 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ display: 'block' }}
                      >
                        <path
                          d="M18.5303 7.03033C18.8232 6.73744 18.8232 6.26256 18.5303 5.96967L13.7574 1.1967C13.4645 0.903806 12.9896 0.903806 12.6967 1.1967C12.4038 1.48959 12.4038 1.96447 12.6967 2.25736L16.9393 6.5L12.6967 10.7426C12.4038 11.0355 12.4038 11.5104 12.6967 11.8033C12.9896 12.0962 13.4645 12.0962 13.7574 11.8033L18.5303 7.03033ZM0 7.25H18V5.75H0V7.25Z"
                          fill="currentColor"
                        />
                      </svg>
                    </Link>
                    <a
                      href="tel:+917440992424"
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '14px 24px',
                        borderRadius: '999px',
                        background: '#ffffff',
                        color: '#111111',
                        fontWeight: 700,
                        fontSize: '15px',
                        textDecoration: 'none',
                        border: '1px solid #e5e7eb',
                        boxShadow: '0 10px 20px rgba(15, 23, 42, 0.08)',
                        transition: 'transform 0.25s ease, background 0.25s ease',
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateY(-2px)';
                        e.currentTarget.style.background = '#f8fafc';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.background = '#ffffff';
                      }}
                    >
                      Call +91-7440992424
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <HomepageFAQ />
    </>
  );
};

export default Contact;